import { ViewStream } from "spyne";
import AuthLoginBtnTmpl from "./templates/auth-login-btn.tmpl.html";
export class AuthViewLoginBtn extends ViewStream {
  constructor(props = {}) {
    props.id = "auth-login-btn";
    props.class = 'auth-view-state-item';
    props.template = AuthLoginBtnTmpl;
    props.channels = [["CHANNEL_AUTH", true]];
    super(props);
  }

  addActionListeners() {
    return [["CHANNEL_AUTH_AUTHENTICATION_EVENT", "disposeViewStream"]];
  }

  broadcastEvents() {
    return [["button", "click"]];
  }

  onRendered() {}
}
